export default "__VITE_ASSET__BaZQPmgy__"